import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class NoDestinationDialog extends React.Component {

  handleClose = () => {
    const { close } = this.props
    close()
  };

  render() {
    const { open } = this.props;

    return (


        <Dialog
          fullScreen={false}
          open={open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"IMPORTANT: You Have Not Selected a Lead Destination"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              By not selecting a lead destination, we will have nowhere to deliver your leads.  Use the 'Add New' button above to select a CRM webhook or email destination, otherwise you will only be able to receive your leads through this dashboard. 
              If a CRM webhook or email has already been added as a destination, use its on/off button to toggle lead delivery at any time.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

    );
  }
}

NoDestinationDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(NoDestinationDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Dialogs/NoDestinationDialog.js